import { Game } from "./core/Game";
import { inject } from '@vercel/analytics';

inject();

// Define interface for Screen Orientation API which might not be fully typed in TypeScript
interface ScreenOrientationAPI {
  lock(orientation: string): Promise<void>;
  unlock(): void;
  type: string;
  angle: number;
}

// Lock screen to landscape orientation if supported
function lockScreenOrientation(): void {
  try {
    // Use type assertion for the orientation API
    const orientation = screen.orientation as unknown as ScreenOrientationAPI;

    if (orientation && typeof orientation.lock === "function") {
      orientation.lock("landscape").catch((error: Error) => {
        console.log("Screen orientation lock failed:", error.message);
      });
    }
  } catch (error) {
    console.log("Screen orientation API not supported");
  }
}

// Initialize the game when the DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  // Try to lock screen orientation
  lockScreenOrientation();

  // Initialize game
  new Game();
});
